module.exports = __webpack_public_path__ + "img/voltage.77a458e8.svg";